const ACCESS_TOKEN_KEY = "access_token" as string;
const REFRESH_TOKEN_KEY = "refresh_token" as string;
import { CookieComponent } from "@/assets/ts/components";

export const getAccessToken = (): string | undefined => {
  return CookieComponent.get(ACCESS_TOKEN_KEY);
};

export const getRefreshToken = (): string | undefined => {
  return CookieComponent.get(REFRESH_TOKEN_KEY);
};

export const saveTokens = (accessToken: string, refreshToken: string): void => {
  CookieComponent.set(ACCESS_TOKEN_KEY, accessToken, {});
  CookieComponent.set(REFRESH_TOKEN_KEY, refreshToken, {});
};

export const destroyTokens = (): void => {
  CookieComponent.delete(ACCESS_TOKEN_KEY);
  CookieComponent.delete(REFRESH_TOKEN_KEY);
};

export default { getAccessToken, getRefreshToken, saveTokens, destroyTokens };
